<template>
    <div>
        <h3>รายงานสรุปการออกเงินเดือน</h3>
        <div class="row form-group">
            <div class="col-4 text-right">วันที่</div>
            <div class="col-6">
                <date-picker v-model="search.date"
                             range
                             class="w-100"
                             placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                    v-model="search.employee"
                    :options="optionEmployee"
                    label="name"
                    placeholder="ค้นหาพนักงาน"
                    :show-labels="false"
                    :customLabel="employeeLabel"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แผนก</div>
            <div class="col-6">
                <multiselect
                    v-model="search.department"
                    :options="optionDepartment"
                    placeholder="ค้นหาแผนก"
                    :show-labels="false"
                    label="department_name"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="col text-center">
            <button  type="button"
                     @click="submitData"
                     class="btn btn-success">
                <icon name="print" style="width: 25px"></icon>
                ตกลง
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";
    import Multiselect from "vue-multiselect";
    export default {
        name: "ReportSalaryModal",
        components:{
            DatePicker,
            Multiselect,
        },
        data(){
            return{
                search :{
                    date : [],
                    employee : '',
                    department : '',
                },
                optionDepartment : [],
                optionEmployee : [],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        created() {
            this.getEmployeeAll();
            this.getDepartmentAll();
            this.$store.dispatch("Employee/setEmployee");
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            getEmployeeAll(){
                this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                    this.optionEmployee = res;
                })
            },
            getDepartmentAll(){
                this.$store.dispatch("Department/getAllDepartment").then(res=>{
                    this.optionDepartment = res;
                })
            },
            submitData(){
                let data = {
                    start_date : this.search.date.length && this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                    end_date : this.search.date.length && this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                    employee_id : this.search.employee ? this.search.employee.id : '',
                    department_id : this.search.department ? this.search.department.id : '',
                }
                if(data.start_date && data.end_date){
                    this.$emit("submit",data);
                }else{
                    alert('กรุณาเลือกวันที่');
                }
            },
            cancelData(){
                this.$emit("submit",false);
            }
        }
    }
</script>

<style scoped>

</style>
